import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadCropperComponent } from './upload-cropper.component';
import { ImageCropperModule } from 'ngx-image-cropper';

@NgModule({
    declarations: [UploadCropperComponent],
    imports: [
        CommonModule,
        ImageCropperModule
    ],
    exports: [UploadCropperComponent]
})
export class UploadCropperModule { }
